var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAward = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 24"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "award_svg__b",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4 0h16v24H4z",
  style: {
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 1.06352
  }
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "award_svg__a",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4 0h16v24H4z",
  style: {
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 1.06352
  }
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 15a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z",
  clipPath: "url(#award_svg__a)",
  transform: "translate(-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.21 13.89 7 23l5-3 5 3-1.21-9.12",
  clipPath: "url(#award_svg__b)",
  transform: "translate(-4)"
}))));
export default SvgAward;